import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const CenteredDiv = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 12rem;
  margin-bottom: 3rem;

  & > h1 {
    color: ${({ theme }) => theme.colors.gray};

    align-items: center;
    display: flex;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 1rem;
    margin-top: 2.5rem;
    img {
      height: 3rem;
      margin-right: 0.5rem;
    }
  }

  & > h2 {
    color: ${({ theme }) => theme.colors.gray72};
    font-size: 1.6rem;
    font-weight: 500;
    margin: 0;
  }

  .requesting-data {
    height: 18.7rem;
    width: 26.6rem;
  }
`;
